import { MenuItem, MenuList } from "@mui/material";
import { CheckboxIcon } from "@shared/frontend/icons";
import React, { FC } from "react";

interface CustomBooleanFilterProps {
  value: boolean | null;
  onChange: React.Dispatch<React.SetStateAction<boolean | null>>;
  allowUnselect?: boolean;
}

const CustomBooleanFilter: FC<CustomBooleanFilterProps> = (props) => {
  const { onChange = () => { }, value, allowUnselect = false } = props;

  function handleSelect(value: boolean) {
    if (!allowUnselect) {
      onChange(value);
    }
    onChange((prev) => (prev === value ? null : value));
  }

  return (
    <MenuList>
      <MenuItem
        key="true"
        sx={{ gap: "0.8rem" }}
        onClick={() => handleSelect(true)}
      >
        <CheckboxIcon
          checked={value === true}
          className="size-4"
          aria-hidden="true"
        />
        <span>כן</span>
      </MenuItem>
      <MenuItem
        key="false"
        sx={{ gap: "0.8rem" }}
        onClick={() => handleSelect(false)}
      >
        <CheckboxIcon
          checked={value === false}
          className="size-4"
          aria-hidden="true"
        />
        <span>לא</span>
      </MenuItem>
    </MenuList>
  );
};

export default CustomBooleanFilter;
